import {
  mainRequests
} from './custom'
export default {
  searchTrackCode (trackCode) {
    return new Promise((resolve, reject) => {
      mainRequests
        .get(`/trackCodes/${trackCode}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  addTrackCode (trackCode, phoneNumber, descriptionTrackCode, userSelectBranch, id, companyId) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/trackCodes', { track_code: trackCode, phone_number: phoneNumber, description: descriptionTrackCode, user_select_branch: userSelectBranch, created_user_id: id, company_id: companyId })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getFAQ () {
    return new Promise((resolve, reject) => {
      mainRequests
        .get('/faqs')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  login (phoneNumber, password) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/login', { phone1: phoneNumber, password: password })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  register (phoneNumber, password, companyId) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/register', { phone1: phoneNumber, password: password, company_id: companyId })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  updateUser (id, firstName, lastName, email, phone1, phone2, address) {
    return new Promise((resolve, reject) => {
      mainRequests
        .putAuth(`/users/${id}`, { firstName, lastName, email, phone1, phone2, address })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  searchTrackCodeByPhoneNumber (phoneNumber) {
    return new Promise((resolve, reject) => {
      mainRequests
        .get(`/trackCodesPhone/${phoneNumber}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getBranch () {
    return new Promise((resolve, reject) => {
      mainRequests
        .get('/branchesWeb')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  // searchTrackCodeByPhoneNumberOrderBy (phoneNumber, progressCode) {
  //   return new Promise((resolve, reject) => {
  //     let link = '/trackCodesPhoneOrderBy?phone_number=' + phoneNumber
  //     if (progressCode != null) {
  //       link = '/trackCodesPhoneOrderBy?phone_number=' + phoneNumber + '&progress_code=' + progressCode
  //     }
  //     mainRequests
  //       .getAuth(link)
  //       .then(res => resolve(res))
  //       .catch(err => reject(err))
  //   })
  // },
  searchTrackCodeByPhoneNumberOrderBy (phoneNumber, progressCode) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodesPhoneOrderBy?phone_number=${phoneNumber}&progress_code=${progressCode}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodeByPhoneNumberOrderByAll (phone) {
    console.log(phone)
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodesPhoneOrderByAll/${phone}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getAddressByOrder (userId) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/addressByOrder/${userId}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createAddress (nickName, detailAddress, lng, lat, userId) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/address', {
          nick_name: nickName,
          detail_address: detailAddress,
          user_id: userId,
          lng: lng,
          lat: lat
        })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  updateAddress (id, nickName, detailAddress, lng, lat) {
    return new Promise((resolve, reject) => {
      mainRequests
        .putAuth(`/address/${id}`, {
          nick_name: nickName,
          detail_address: detailAddress,
          lng: lng,
          lat: lat
        })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  viewAddress (userId) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/address/${userId}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getOrderDetail (id) {
    return new Promise((resolve, reject) => {
      mainRequests
        .get(`/trackCodes/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createProgress (progressCode, trackCodeId, addressId, startDate, endDate, hvrgvvlehOgnoo, ochijAvahOgnoo) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/progress', { progress_code: progressCode, track_code_id: trackCodeId, address_id: addressId, start_date: startDate, end_date: endDate, hvrgvvleh_ognoo: hvrgvvlehOgnoo, ochij_avah_ognoo: ochijAvahOgnoo })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodeById (id) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodesId/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getBanners () {
    return new Promise((resolve, reject) => {
      mainRequests
        .get('/bannersWeb')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getUserById (id) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/users/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  sendRequestOtp (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/otp/request', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  resetPassword (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .post('/otp/verify', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getConfigLast () {
    return new Promise((resolve, reject) => {
      mainRequests
        .get('/configLast')
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  calculatePrice (configTypeId, jin, urt, undur, urgun) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/calculatePrice', { config_type_id: configTypeId, jin: jin, urt: urt, undur: undur, urgun: urgun })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getActiveConfig (data) {
    return new Promise((resolve, reject) => {
      mainRequests
        .get(`/config/${data}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getTrackCodeByCode (trackCode) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodesByCode/${trackCode}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createTrackCodesAndProgress (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/trackCodesAndProgress', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  deliveryPrice (trackCodes) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/deliveryPrice', { track_codes: trackCodes })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getOchijAvahPrice (trackCodes) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/ochijAvahAmount', { track_code: trackCodes })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  deleteTrackCode (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth(`/trackCodes/${payload}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  trackCodeCountByPhone (phoneNumber) {
    return new Promise((resolve, reject) => {
      mainRequests
        .getAuth(`/trackCodeCount?phone_number=${phoneNumber}`)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  cuponPrice (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/cuponPrice', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  createCheckTrackCode (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/checkTrackCode', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  changePassword (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/changePassword', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
  getHvrgelt (payload) {
    return new Promise((resolve, reject) => {
      mainRequests
        .postAuth('/deliveryList', payload)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }
}
